<template>
  <div
    ref="searchInputBox"
    class="component-search-input-box"
    @touchmove="touchmove"
  >
    <form
      onsubmit="return false;"
      action
      class="search-input-form"
      @submit="onFormSubmit"
      clstag="jr|keycount|8530054_classify_index_searchbox|check"
    >
      <div
        class="back-btn-wrapper"
        v-if="hasBackBtn"
      >
        <div
          class="back-btn"
          @click="onClickBack"
          v-if="!this.searched"
        >
          <span class="back-icon"></span>
        </div>
      </div>
      <div class="left-wrapper">
        <div
          class="search-input-wrapper"
          @click="onClickInputWrapper"
        >
          <div class="search-icon"></div>
          <div
            class="search-tags-wrapper"
            v-if="searched && searchKey"
          >
            <div class="search-tags-inner">
              <div class="search-tags-inner-content">
                <div class="search-tags-key ellipsis">{{searchKey}}</div>
                <i
                  class="tags-clear-icon"
                  @click="onClickSearchInputClear"
                ></i>
              </div>
            </div>
          </div>
          <div
            class="search-input-inner"
            v-if="!searched || !searchKey"
          >
            <div class="search-input-p">
              <input
                type="search"
                maxlength="50"
                class="input-search"
                :placeholder="searchDefaultPlaceholder"
                v-model.trim="searchKey"
                autocomplete="off"
                @input="onInputSearchInput"
                @blur="onInputBlur"
              >
            </div>
            <div class="clear-icon-wrapper">
              <i
                class="clear-icon"
                @click="onClickSearchInputClear"
                v-if="searchKey"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="search-btn"
        v-if="!this.searched"
        @click="onClickSearchBtn"
      >搜索</div>
    </form>
    <div
      class="jrm-border-1px jrm-border-top search-auto-suggestion-area"
      v-if="!searched"
      :style="{height: height,top:top }"
      @touchmove="onTouchmoveSuggestion"
    >
      <ScrollView
        ref="scrollViewSuggestion"
        class="scroll-view-wrapper scroll-view-suggestion"
        :probeType="1"
        :bounce="false"
        :enableAutoRefresh="true"
        :data="searchListSuggestion"
      >
        <div class="search-main-scroll">
          <div
            class="empty-suggestion-panel"
            v-if="!searchKey"
          >
            <!-- 热搜第一期做 -->
            <div
              class="empty-title"
              v-if="hotSearchList && hotSearchList.length"
            >
              <span class="empty-left">热搜</span>
              <!-- <span class="empty-right" @click="onClickChangeOneChange">换一批</span> -->
            </div>
            <ul
              class="jrm-bfc empty-ul"
              v-if="hotSearchList && hotSearchList.length"
            >
              <li
                class="ellipsis"
                v-for="(name,index) in hotSearchList"
                :key="index"
                @click="onClickSuggestion($event,{name})"
                :clstag="'jr|keycount|8530054_classify_keywords_hot|'+name"
              >{{name}}</li>
            </ul>
            <div
              class="empty-title"
              v-if="historySearchList && historySearchList.length"
            >
              <div class="empty-left">历史搜索</div>
              <div
                class="empty-right"
                @click="onClickClearHistory"
              >清除</div>
            </div>
            <ul
              class="jrm-bfc empty-ul"
              v-if="historySearchList && historySearchList.length"
            >
              <li
                class="ellipsis"
                v-for="(item,index) in historySearchList"
                :key="index"
                @click="onClickSuggestion($event,item)"
                :clstag="'jr|keycount|8530054_classify_keywords_history|'+item.name"
              >{{item.name}}</li>
            </ul>
          </div>
          <div
            class="suggestion-panel"
            v-else
          >
            <ul class="suggestion-panel-ul">
              <li
                class="jrm-border-1px jrm-border-bottom ellipsis"
                v-for="(item,index) in searchListSuggestion"
                :key="index"
                @click="onClickSuggestion($event,item)"
                :clstag="'jr|keycount|jdjr_search_suggestion|word_'+item.name"
              >
                <span
                  class="highlight"
                  v-if="item.viewName"
                >{{item.viewName}}</span>
                <span>{{item.viewDesp}}</span>
              </li>
            </ul>
          </div>
        </div>
      </ScrollView>
    </div>
  </div>
</template>

<script>
import ScrollView from '@/components/ScrollView.vue';
import { delay, getStaticConfig, isMiniProgram } from '@/util/common';
import { toSearchPage, searchTrim } from '@/util/searchUtil';
import request from '@/util/request';
import { HideShare } from '@/util/share';
import { saveToHistoryList, searchHistoryList, clearHistoryList } from '@/util/storageSearchHistory';

const SEARCHBOXHASH = '__sbox__';

export default {
  name: 'SearchInputBox',
  components: {
    ScrollView
  },
  data() {
    return {
      height: '100%',
      top: '',
      isShowSuggestion: false,
      isEmpty: false,
      searched: true,
      searchKey: '',
      searchedKey: '',
      hasLoadedHotSearchList: false,
      hasBackBtn: false,
      hotSearchList: [],
      historySearchList: [],
      searchListSuggestion: [],
      searchedKeySuggestion: '',
      searchDefaultKey: getStaticConfig('searchDefaultKey') || '手机',
      searchDefaultPlaceholder: getStaticConfig('searchDefaultPlaceholder') || '搜索京东全部商品'
    };
  },
  props: {
    searchFirstKey: {
      type: String,
      default: ''
    },
    isAutoSearch: {
      type: Boolean,
      default: false
    },
    hasSetTilte: {
      type: Boolean,
      default: true
    },
    isFirstBlockTheme: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  created() {
    // 用hash控制搜索框
    this.onClickBack();

    this.searchKey = this.searchFirstKey || '';

    this.bindHashChange = () => {
      console.log('search box bindHashChange');
      this.onHashChange();
    };

    delay(() => {
      if ($) {
        $(window).on('hashchange', this.bindHashChange);
      }
    }, 300);

    if (isMiniProgram()) {
      this.hasBackBtn = true;
    }
  },
  methods: {
    touchmove(e) {
      e.preventDefault();
    },
    onClickBack() {
      if (location.hash.indexOf(SEARCHBOXHASH) > -1) {
        history.go(-1);
      }
      this.onInputBlur();
    },
    onTouchmoveSuggestion() {
      this.onInputBlur();
    },
    onClickFilter(item, index) {
      console.log(item, index);
    },
    // 点击取消搜索
    onClickCancel() {
      window.history.go(-1);
    },
    // 点击搜索Wrapper
    onClickInputWrapper() {
      this.showPanle();
    },
    // 点击输入框的清楚按钮
    onClickSearchInputClear() {
      this.searchKey = '';
    },
    // 搜索框输入响应
    onInputSearchInput() {
      console.log(this.searchKey);
      delay(() => {
        this.requestSearchSuggestion();
      }, 150);
    },
    // 搜索框的获得焦点
    // onInputSearchFocus() {
    //   this.showPanle();
    // },
    // 点击Suggestion
    onClickSuggestion(e, item) {
      this.searchKey = item.name;
      this.searched = true;
      this.emitInputSearched();
    },
    // 点击搜索按钮
    onClickSearchBtn() {
      if (!this.searchKey) {
        this.searchKey = this.searchDefaultKey;
      }
      this.emitInputSearched();
    },
    onFormSubmit(e) {
      this.onClickSearchBtn();

      e.preventDefault();
    },
    onInputBlur() {
      delay(() => {
        $('input').blur();
      }, 200);
    },
    // 点击换一换
    onClickChangeOneChange() {
      this.hotSearchList = [];
    },
    // 点击清空历史
    onClickClearHistory() {
      this.historySearchList = [];
      clearHistoryList();
    },
    // 显示Suggestion面板
    showAutoSuggestion() {
      console.log($(this.$refs.searchInputBox));
      const height = $(this.$refs.searchInputBox).height();

      this.top = `${height}px`;
      this.height = `${$(document).height() - height}px`;
      this.isShowSuggestion = true;
    },
    emitInputSearched() {
      // this.$emit('onInputSearched', { searchKey: this.searchKey });

      // if (this.isAutoSearch) {
      this.searchByLocationHref();
      // }
    },
    showPanle() {
      const hash = window.location.hash.split('?')[0];
      if (hash.indexOf('?') > -1) {
        window.location.hash = hash + `&${SEARCHBOXHASH}`;
      } else {
        window.location.hash = hash + `?${SEARCHBOXHASH}`;
      }

      this.requestHotSearchAssociative();
    },
    setTitle({ delayTime }) {
      if (this.hasSetTilte && $.device && $.device.jdjr) {
        let backColor = '#FFFFFF';
        let textColor = 2;

        if (this.searched && this.isFirstBlockTheme) {
          backColor = '#000000';
          textColor = 1;
        }

        delay(() => {
          HideShare({
            title: window.document.title,
            moreItem: true,
            backColor,
            textColor: textColor
          });
        }, delayTime || 10);
      }
    },
    onHashChange() {
      if (window.location.hash.indexOf(SEARCHBOXHASH) === -1) {
        this.overFlowAuto();

        this.searched = true;
        this.searchKey = this.searchedKey;

        delay(() => {
          $('input').blur();
        }, 200);
      } else {
        this.overFlowHidden();
        this.searched = false;
        this.searchedKey = this.searchKey;
        if (this.searchKey) {
          this.requestSearchSuggestion();
        }
      }

      this.$emit('onHashChange', { SEARCHBOXHASH, searched: this.searched });

      this.setTitle({});
    },
    searchByLocationHref() {
      const sk = searchTrim(this.searchKey);
      toSearchPage({
        sk
      });

      this.reset();
    },
    requestSearchSuggestion() {
      const _searchKey = searchTrim(this.searchKey);
      if (this.lockRequestSearchSuggestion || !_searchKey || this.searchedKeySuggestion === _searchKey) {
        return;
      }
      this.lockRequestSearchSuggestion = true;

      request.searchAssociative({
        data: {
          searchWords: _searchKey,
          size: '10'
        },
        success: ({ assoviatives }) => {
          this.lockRequestSearchSuggestion = false;
          this.searchedKeySuggestion = _searchKey;
          const suggestions = [];
          if (this.searchKey && assoviatives && assoviatives.length) {
            assoviatives.map(name => {
              const rst = {};
              if (name) {
                if (name.indexOf(_searchKey) === 0) {
                  rst.viewName = _searchKey;
                  rst.viewDesp = name.substring(_searchKey.length);
                } else {
                  rst.viewDesp = name;
                }

                rst.name = name;
              }

              suggestions.push(rst);
            });
          }

          this.searchListSuggestion = suggestions;
        },
        error: () => {
          this.lockRequestSearchSuggestion = false;
        }
      });
    },
    // 加载热搜
    requestHotSearchAssociative() {
      if (this.hasLoadedHotSearchList) {
        return;
      }

      request.hotSearchAssociative({
        success: ({ hotSearchList }) => {
          this.hasLoadedHotSearchList = true;
          if (hotSearchList && hotSearchList.length) {
            this.hotSearchList = hotSearchList;
          }
        },
        error: () => {
          this.hasLoadedHotSearchList = true;
        }
      });
    },
    refresh() {
      this.$nextTick(() => {
        if (this.$refs && this.$refs.scrollViewSuggestion && this.$refs.scrollViewSuggestion.refresh) {
          console.log('refresh');
          this.$refs.scrollViewSuggestion.refresh();
        }
      });
    },
    overFlowHidden() {
      // try {
      //   if ($.device && $.device.iphone && $.device.pixelRatio === 2 && String($.device.osVersion) === '8.3') {
      //     $('.search-page')
      //       .data('scrolltop', document.documentElement.scrollTop || document.body.scrollTop)
      //       .css({ overflow: 'hidden', height: '100%' });
      //   }
      // } catch (e) {
      //   console.log(e);
      // }
    },
    overFlowAuto() {
      // try {
      //   if ($.device && $.device.iphone && $.device.pixelRatio === 2 && String($.device.osVersion) === '8.3') {
      //     const $page = $('.search-page');
      //     const scrollTop = $page.data('scrolltop');
      //     $page.css({ overflow: '', height: '' });
      //     window.scrollTo && window.scrollTo(0, scrollTop);
      //   }
      // } catch (e) {
      //   console.log(e);
      // }
    },
    reset() {
      this.searchKey = '';
      this.onClickBack();
    }
  },
  watch: {
    searched() {}
  },
  mounted() {
    if (this.searchKey) {
      saveToHistoryList(this.searchKey);
    }
    this.historySearchList = searchHistoryList() || [];

    this.setTitle({ delayTime: 10 });
    let { mini_search } = this.$route.query;
    console.log(mini_search);
    if (mini_search == '1') {
      setTimeout(() => {
        this.onClickInputWrapper();
      }, 600);
    }
  },
  beforeDestroy() {
    if ($) {
      $(window).off('hashchange', this.bindHashChange);
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
    if ($) {
      $(window).off('hashchange', this.bindHashChange);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/mixin.scss';
$search-input-box-height: $rem68 + $rem20;
.component-search-input-box {
  background-color: #fff;
  height: $search-input-box-height;
  padding: $rem10 $rem32;

  .search-input-form {
    height: $rem68;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow: hidden;

    .back-btn-wrapper {
      width: $rem39;
      height: 100%;
    }

    .back-btn {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;

      .back-icon {
        width: $rem19;
        height: $rem36;
        display: block;
        background: url(https://img12.360buyimg.com/jrpmobile/jfs/t1/19491/19/275/801/5c08988eE416efb6a/1db5db8d94961f02.png) no-repeat;
        background-size: 100% 100%;
      }
    }

    .left-wrapper {
      width: 100%;
      height: 100%;
      flex: 1;

      .search-input-wrapper {
        width: 100%;
        height: 100%;
        padding-left: $rem20;
        padding-right: $rem20;
        background: #f2f2f2;
        border-radius: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .search-tags-wrapper {
          flex: 1;
          padding-left: $rem20;
          height: $rem52;
          overflow: hidden;
        }

        .search-tags-inner {
          max-width: 100%;
          padding: 0 $rem20;
          height: 100%;
          background: #999999;
          border-radius: 100px;
          display: inline-block;

          .search-tags-inner-content {
            height: 100%;
            display: flex;
            align-items: center;
          }

          .search-tags-key {
            flex: 1;
            height: $rem28;
            font-size: $rem28;
            line-height: $rem28;
            color: #ffffff;
          }

          .tags-clear-icon {
            display: inline-block;
            margin-left: $rem26;
            width: $rem24;
            height: $rem24;
            background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/5324/9/11624/291/5bd04624E50bd3f7f/aa0222bdb048963e.png');
            background-position: 0 0;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }

        .search-input-inner {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .search-input-p {
          flex: 1;
          margin-left: $rem20;
          margin-right: $rem20;
        }

        .input-search {
          width: 100%;
          height: $rem40;
          line-height: $rem40;
          background: inherit;
          font-size: $rem28;
          color: #222222;
          appearance: none;
        }

        .search-icon {
          width: $rem30;
          height: $rem30;
          background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/722/20/11552/854/5bcf1729Ebb6e4ddc/dccad69c41df952f.png');
          background-position: 0 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .clear-icon-wrapper {
          width: $rem30;
          height: $rem30;
        }

        .clear-icon {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/427/16/11642/735/5bcf1873E5836e94d/53a0da624eee285a.png');
          background-position: 0 0;
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }

    .search-btn {
      margin-left: $rem20;
      width: $rem96;
      height: $rem56;
      line-height: $rem56;
      background: #c29451;
      color: #fff;
      border-radius: $rem8;
      font-size: $rem28;
      text-align: center;
    }
  }

  .search-auto-suggestion-area {
    position: fixed;
    left: 0;
    top: $search-input-box-height;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 10000;

    .scroll-view-suggestion {
      overflow: hidden;
    }

    .empty-suggestion-panel {
      padding: $rem40 $rem32;

      .empty-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: $rem32;
      }

      .empty-left {
        font-family: PingFangSC-Medium;
        flex: 1;
        font-size: $rem32;
        color: #333333;
        line-height: $rem32;
      }

      .empty-right {
        font-size: $rem24;
        color: #c29451;
        line-height: $rem24;
      }

      .empty-ul {
        margin-top: $rem40;
        margin-bottom: $rem14;

        li {
          max-width: $rem320;
          float: left;
          margin-right: $rem20;
          margin-bottom: $rem20;
          height: $rem66;
          line-height: $rem66;
          text-align: center;
          padding: 0 $rem30;
          background: #f7f7f7;
          border-radius: 100px;
          font-size: $rem28;
          color: #666666;
        }
      }
    }

    .suggestion-panel {
      .suggestion-panel-ul {
        // padding-bottom: 260px;

        li {
          position: relative;
          padding-left: $rem32;
          padding-right: $rem70;
          width: 100%;
          height: $rem82;
          line-height: $rem82;
          font-size: $rem26;
          color: #222222;

          .highlight {
            color: #c29451;
          }

          &:after {
            position: absolute;
            top: $rem24;
            right: $rem32;
            width: $rem32;
            height: $rem32;
            content: '';
            background-image: url('//img12.360buyimg.com/jrpmobile/jfs/t1/4670/39/11465/333/5bcfe21fE6cafe786/41c57ef8d2aa576e.png');
            background-position: 0 0;
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
        }
      }
    }

    .empty-suggestion-panel,
    .suggestion-panel {
      // width: 100%;
      // height: 100%;
      padding-bottom: $rem100;
      // overflow-y: auto;
      // -webkit-overflow-scrolling: touch;
    }
  }

  input[type='search']::-webkit-search-cancel-button {
    display: none;
  }
}

@media screen and (max-width: 320px) {
  .component-search-input-box .search-auto-suggestion-area .empty-suggestion-panel .empty-ul {
    li {
      max-width: $rem264;
    }
  }
}

@media screen and (min-width: 414px) {
  .component-search-input-box .search-auto-suggestion-area .empty-suggestion-panel .empty-ul {
    li {
      max-width: $rem360;
    }
  }
}
</style>
